import * as React from "react"
import { cn } from "@/lib/utils"

export interface XIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * X (formerly Twitter) icon as SVG
 *
 * This icon represents the X social network platform.
 *
 * @example
 * ```tsx
 * <XIcon />
 * <XIcon size={24} className="text-black" />
 * ```
 */
export const XIcon = React.forwardRef<SVGSVGElement, XIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M14.2134 0.996094H16.9414L10.9034 7.89809L18.0034 17.0041H12.4554L8.09137 11.3961L3.11537 17.0041H0.385371L6.84137 9.63409L0.00537109 0.996094H5.69337L9.64137 6.12809L14.2134 0.996094ZM13.2714 15.3641H14.7914L4.78537 2.54809H3.15537L13.2714 15.3641Z" />
      </svg>
    )
  }
)

XIcon.displayName = "XIcon"
